/** @jsxImportSource theme-ui @jsxRuntime classic */
import { graphql } from 'gatsby';
import React from 'react';

import {
  BuyTicketsAddOnStepBlock,
  BuyTicketsComboStepBlock,
  BuyTicketsDateStepBlock,
  BuyTicketsIntroBlock,
  BuyTicketsTicketStepBlock,
} from '../../blocks/VivaBuyTickets';
import { BuyTicketsVariantPageData, Wizard } from '../../components/BuyTickets';
import { BuyTicketsLayout } from '../../layouts/BuyTicketsLayout';
import { Attraction, BosEvent, Flow } from '../../services/viva/constants';
import { useTicketEditMode } from '../../utils/use-ticket-edit-mode';

import type { PageConfig } from '../../PageConfig';

export const pageConfig: PageConfig = {
  theme: 'Rock Center Black',
  pageName: null,
  logo: 'Observation Deck Buy Tickets',
  hideSearchToggleButton: true,
  leftNav: {
    to: '/buy-tickets/#rockefeller-center-tour',
    label: 'BACK',
    variant: 'buyTicketsMenuBarBackArrow',
  },
};

export default function TopOfTheRockTickets({
  data,
}: {
  data: Queries.BuyTicketsRockPassQuery;
}): React.JSX.Element {
  useTicketEditMode(Flow.RC_ROCK_PASS);

  return (
    <BuyTicketsLayout
      attraction={Attraction.TopOfTheRockObservationDeck}
      data={data as BuyTicketsVariantPageData}
      event={BosEvent.RC_ROCK_PASS}
      flow={Flow.RC_ROCK_PASS}
    >
      <BuyTicketsIntroBlock />
      <Wizard totalSteps={5} width="wide">
        <BuyTicketsTicketStepBlock
          hideLabel={true}
          stepNumber={1}
          width="wide"
        />
        <BuyTicketsDateStepBlock
          data={data as BuyTicketsVariantPageData}
          stepNumber={2}
          width="wide"
        />
        <BuyTicketsComboStepBlock
          data={data as BuyTicketsVariantPageData}
          firstStepNumber={3}
          secondStepNumber={4}
          width="wide"
        />
        <BuyTicketsAddOnStepBlock
          allowedFlows={[Flow.RC_ROCK_PASS]}
          data={data as BuyTicketsVariantPageData}
          stepNumber={5}
          width="wide"
        />
        {/* <AddToCart stepNumber={5} /> */}
      </Wizard>
    </BuyTicketsLayout>
  );
}

export const query = graphql`
  query BuyTicketsRockPass {
    meta: buyTicketsFlowRockPassJson(jsonId: { eq: "en-US" }) {
      meta {
        title
        description
      }
    }
    page: buyTicketsFlowRockPassJson(jsonId: { eq: "en-US" }) {
      hero {
        title
      }
      ticketStep {
        title
        description
        ticketTypes {
          label
          ticketTypeId
        }
      }
      dateStep {
        title
        description
      }
      comboStep {
        tour {
          title
          description
          kidsTourDescription
        }
        deck {
          title
          description
        }
      }
      purchaseStep {
        title
      }
    }
    allSanityTicketCategory(
      filter: { tickets: { elemMatch: { slugId: { eq: "rock-pass" } } } }
    ) {
      nodes {
        tickets {
          slugId
          _rawWhatsIncluded
        }
      }
    }
  }
`;
